import AccessoriesImage from '../images/negativ-akcesoria-metalowe.webp';
import ZippersImage from '../images/negativ-suwaki-zippers.webp';
import PhoneImage from '../images/negativ-telefon-messenger.webp';
import CustomImage from '../images/negativ-custom-orders.webp';
import FabricsImage from '../images/negativ-tkaniny-kupony.webp';
import Fabrics2Image from '../images/lnegativ-lampasy-gumy.webp';

import '../css/perks.css';

import CopyButton from './copybutton';

import useDictionary from '../hooks/useDictionary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faCompassDrafting, faMessage, faPhone, faScissors, faShoppingBag, faSms } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

export default function OurPerks() {

    const dictionary = useDictionary();

    return (
        <>
        <div className="our-perks">
            
            <div className="perk">
                <div className="title">
                    {dictionary.OWN_HARDWARE}
                </div>
                <div className="description">
                    <p>{dictionary.PERK_TEXT_1}</p><div className="image"><img alt="Negativ Premium Fashion Accessories" src={AccessoriesImage} /></div><p>{dictionary.PERK_TEXT_2}</p> <div className="image"><img alt="Negativ Premium Quality Zippers" src={ZippersImage} /></div> <p>{dictionary.PERK_TEXT_2A}</p>
                </div>

                <div className="horizontal-line default-hidden show-on-768"></div>

                <div className="title">
                    {dictionary.DIRECT_CONTACT}
                </div>
                <div className="description">
                    <p>{dictionary.PERK_TEXT_7}</p><div className="image"><img alt="Negativ Customer Service Experience" src={PhoneImage} /></div><p>{dictionary.PERK_TEXT_8}</p>
                    <div style={{paddingBottom: "40px", paddingTop: "10px", textAlign: "center"}}>
                        <a href="https://m.me/NegativFashion" target="_blank" rel="noreferrer" className="univ-button">{dictionary.OPEN_MESSENGER}</a>
                    </div>
                </div>

            </div>

            <div className="perk">

                <div className="title">
                    {dictionary.CUSTOM_FABRICS}
                </div>
                <div className="description">
                    <p>{dictionary.PERK_TEXT_3}</p> <div className="image"><img alt="Negativ Fabrics" src={FabricsImage} /></div> <p>{dictionary.PERK_TEXT_4}</p> <div className="image" style={{paddingBottom: "10px"}}><img alt="Negativ Genuine Prints and Fabrics" src={Fabrics2Image} /></div> 
                </div>

                <div className="hotline default-hidden show-on-768">
                    <div className="text">{dictionary.DO_YOU_HAVE_QUESTION}</div>
                    <div className="numbers">
                        <FontAwesomeIcon icon={faPhone} /> <a href="tel:+48222442245">222 44 22 45</a><br />
                        <FontAwesomeIcon icon={faSms} /> <FontAwesomeIcon icon={faWhatsapp} /> <a href="tel:+48792707070">792 70 70 70</a>
                    </div>
                    <div className="text">{dictionary.HOT_LINE_WORK_HOURS}<br />{dictionary.FROM} <span>9:00</span> {dictionary.TO} <span>16:00</span></div>
                    <div className="text">{dictionary.WRITE_TO_US}</div>
                    <div className="text"><CopyButton tekst="info@negativ.com.pl" /></div>
                </div>
            </div>

            <div className="perk">

                <div className="title">
                    {dictionary.CUSTOM_ORDERS}
                </div>
                <div className="description">
                    <p>{dictionary.PERK_TEXT_5}</p><div className="image"><img alt="Negativ Custom Orders" src={CustomImage} /></div><p>{dictionary.PERK_TEXT_6}</p>
                </div>

                <div className="steps">

                    <div className="step">

                        <div className="icon">
                            <FontAwesomeIcon icon={faMessage} />
                        </div>

                        <div className="title">
                            {dictionary.CONSULTING}
                        </div>

                        <div className="description">
                            {dictionary.MEET_REQUIREMENTS}
                        </div>

                    </div>

                    <div className="step-arrow">
                        <FontAwesomeIcon icon={faArrowDown} className="down" />
                    </div>

                    <div className="step">

                        <div className="icon">
                            <FontAwesomeIcon icon={faCompassDrafting} />
                        </div>

                        <div className="title">
                            {dictionary.PROJECT}
                        </div>

                        <div className="description">
                            {dictionary.CREATE_PROJECT}
                        </div>

                    </div>                    

                    <div className="step-arrow">
                        <FontAwesomeIcon icon={faArrowDown} className="down" />
                    </div>

                    <div className="step">

                        <div className="icon">
                            <FontAwesomeIcon icon={faScissors} />
                        </div>

                        <div className="title">
                            {dictionary.IMPLEMENTATION}
                        </div>

                        <div className="description">
                            {dictionary.SEWING_PROCESS}
                        </div>

                    </div>                    

                    <div className="step-arrow">
                        <FontAwesomeIcon icon={faArrowDown} className="down" />
                    </div>

                    <div className="step">

                        <div className="icon">
                            <FontAwesomeIcon icon={faShoppingBag} />
                        </div>

                        <div className="title">
                            {dictionary.PRODUCT_READY}
                        </div>

                        <div className="description">
                            {dictionary.UNIQUE_ITEM}
                        </div>

                    </div>                    

                </div>

                <div className="description">
                    <p>{dictionary.CRAZY_IDEA}</p>

                    <div style={{paddingBottom: "40px", paddingTop: "10px", textAlign: "center"}} className="hide-on-768">
                        <a href="https://m.me/NegativFashion" target="_blank" rel="noreferrer" className="univ-button">Śmiało! Otwórz messenger!</a>
                    </div>
                </div>

            </div>
            
        </div>

        </>
    )
}